// @ts-ignore
// @ts-nocheck
export class HttpHeaderHelper {
    key?: string;
    value?: string;

    constructor(key: string, value: string) {
        this.key = key;
        this.value = value;
    }

    get getKey() {
        return this.key;
    }

    get getValue() {
        return this.value;
    }

    set setKey(key: string) {
        this.key = key;
    }

    set setValue(value: string) {
        this.value = value;
    }
}